import axios from 'axios';
import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.access_token) {
      config.headers['Authorization'] = 'Bearer ' + user.access_token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== '/auth/login' && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await authService.refreshToken();
          api.defaults.headers.common['Authorization'] = 'Bearer ' + rs;
          return api(originalConfig);
        } catch (_error) {
          authService.logout();
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default api;